<template>
    <div class="nav-right">
        <!-- 开通会员 -->
        <div class="open-vip" @click="openVip">
            <img src="@/assets/navbar/vip-icon.png" alt="" />开通会员
        </div>
        <!-- 登录/注册 -->
        <div v-if="!userInfo" class="login-register" @click="handleLoginButton">登录/注册</div>
        <div v-if="userInfo" class="login-info">
            <el-dropdown>
                <span class="el-dropdown-link">
                    <el-image
                        class="default-avt"
                        :src="userInfo ? userInfo.avatar : '@/assets/logo.png'"
                    >
                        <div slot="error" class="image-slot">
                            <!-- <i class="el-icon-picture-outline"></i> -->
                            <img src="@/assets/logo.png" style="width: 40px" />
                        </div>
                    </el-image>
                    <span class="user-name" :title="userInfo ? userInfo.userName : '微观世界'">{{
                        userInfo ? userInfo.userName : '微观世界'
                    }}</span>
                    <img class="info-arrow" src="@/assets/navbar/info-arrow.png" />
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>
                        <div class="drop-item" @click="logoutFn">
                            <img src="@/assets/vip/getout-icon.png" alt="" /><span>退出登录</span>
                        </div>
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
        <!-- 登录通用组件 -->
        <Login v-if="showLogin" :showLogin="showLogin" @closeLogin="closeLogin" />
    </div>
</template>
<script>
import { eventBus } from '@/utils/eventBus'
import Login from '@/components/Login'
import { logout, getInfo } from '@/api/login'
import { getCookie, getUrlParam } from '@/utils/index'

export default {
    name: 'NavRight',
    components: {
        Login,
    },
    data() {
        return {
            // 登录框
            showLogin: false,
            bindPhoneVisitable: false,
            showPayVipPage: false,
            // 用户信息
            userInfo: null,
            token: null,
        }
    },
    async mounted() {
        // 重定向判断
        await this.getRedirctUrl()
        // 1. 绑定 visibilitychange 事件
        document.addEventListener('visibilitychange', this.handleTabChange)

        await this.getInfoFn()

        // 监听事件，控制登录状态失效
        eventBus.$on('showLogin', flag => {
            this.showLogin = flag // 接收事件，控制显示
        })
    },
    beforeUnmount() {
        // 解绑事件（避免组件销毁后事件仍触发）
        document.removeEventListener('visibilitychange', this.handleTabChange)
    },
    watch: {
        // 强制监听userInfo的所有内部变化
        '$store.state.loginInfo': {
            handler(newVal) {
                if (newVal) {
                    // 箭头函数继承 handler 的 this（组件实例）
                    // this.getInfoFn();
                    console.log('newVal:', newVal)
                    this.userInfo = newVal.userInfo
                    this.token = newVal.token
                }
            },
            deep: true, // 关键：开启深层监听
            immediate: true, // 是否初始加载时立即执行（默认false）
        },
        showLogin: {
            // 监听登录框状态，控制页面滚动条状态
            handler(newVal, oldVal) {
                const html = document.documentElement
                const body = document.body
                // 简化判断逻辑
                html.style.overflow = newVal ? 'hidden' : ''
                body.style.overflow = newVal ? 'hidden' : ''
            },
            deep: true, // 如果 package 是对象/数组，需要深层监听内部变化
            immediate: true, // 是否在初始加载时立即执行一次（可选）
        },
    },
    methods: {
        // 判断是否从CRM，地图页面退出登录后跳转过来的
        getRedirctUrl(){
            let redirectUrl = getUrlParam('redirectUrl')
            console.log('需要重定向地址redirectUrl:', redirectUrl)
            if(redirectUrl){
                // 如果重定向存在则说是未登录状态，则清除token
                localStorage.removeItem('token')
                localStorage.removeItem('userInfo')
                // 如果重定向存在，并且非登录状态下，则将显示登录框
                this.handleLoginButton()
            }
            Promise.resolve(true)
        },
        // 监听标签页切换事件
        handleTabChange() {
            if (document.hidden) {
                // Tab 切换到后台（页面不可见）
            } else {
                // Tab 切回前台（页面可见）
                // 获取当前路由地址
                // let currentRoute = this.$route.path;
                // if(currentRoute == "/vip"){
                //   window.location.reload();
                // }
                this.getInfoFn()
            }
        },
        // 通过主域名或二级域名共享cookie，实现一端登录其他免登录，获取用户信息
        async getInfoFn() {
            try {
                // 如果缓存中有直接获取用户信息
                if (
                    localStorage.userInfo &&
                    localStorage.token &&
                    localStorage.userInfo != 'undefined'
                ) {
                    this.userInfo = JSON.parse(localStorage.userInfo)
                    this.token = localStorage.token
                    return
                }
                // 如果当前域名下没有缓存则取父级或二级域名下cookie中找，都没有则是没有登录
                if (!this.token && getCookie('token')) {
                    const token = getCookie('token')
                    localStorage.setItem('token', token)
                    let res = await getInfo(token)
                    let userInfo = res.data.user
                    this.userInfo = userInfo
                    this.token = token
                    this.$store.commit('SET_LOGIN_INFO', {
                        token: token,
                        userInfo: userInfo,
                    })
                    // 检查当前路由是否已经是目标路由
                    const currentRoute = this.$route.path
                    const targetRoute = localStorage.getItem('wantedRoute')

                    if (currentRoute !== targetRoute && targetRoute) {
                        setTimeout(() => {
                            this.$router.push(targetRoute)
                        }, 0)
                    }
                    window.location.reload() // 刷新页面
                } else {
                    console.log('未登录')
                    this.userInfo = null
                    this.token = null
                }
            } catch (error) {}
        },
        // 跳转会员页面
        openVip() {
            // 开通会员直接让他跳转过去
            this.$router.push('/vip')
            // if (this.userInfo) {
            //   this.$router.push("/vip");
            // } else {
            //   // 未登录状态下存储想要跳转的路由
            //   this.$store.commit("SET_WANTED_ROUTE", "/vip");
            //   this.showLogin = true; // 打开登录页面
            // }
        },
        // 打开登录框
        handleLoginButton() {
            this.showLogin = true
        },
        // 关闭登录框
        closeLogin() {
            this.showLogin = false
        },
        // 退出登录
        async logoutFn() {
            try {
                await logout()
                this.token = null
                this.userInfo = null
                // 清除vuex中的登录信息
                this.$store.commit('CLEAR_WANTED_ROUTE')
                await this.$store.dispatch('logout')
                this.$message.success('退出成功')

                const targetPath = '/'
                // 检查是否有重定向路径，有的话点击退出则重置到首页
                let redirectPath = this.$route.query.redirectUrl
                // 检查当前路由是否已经是目标路由
                if (this.$route.path !== targetPath || redirectPath) {
                    this.$router.replace(targetPath)
                }
            } catch (error) {
                this.$message.error('退出失败')
                console.log('退出失败', error)
            }
        },
    },
}
</script>
<style lang="less" scoped>
.nav-right {
    display: flex;
    font-size: 14px;
    color: #333;
    align-items: center;
    .open-vip {
        color: #333;
        width: 103px;
        height: 32px;
        background: linear-gradient(91deg, #fceddf 0%, #fdd3b2 100%);
        border-radius: 5px 5px 5px 5px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 16px;
        cursor: pointer;
        &:hover {
            background: linear-gradient(91deg, #fceddf 0%, #ffaf71 100%);
        }
    }
    .login-register {
        width: 93px;
        height: 32px;
        background: #d5fffb;
        border-radius: 5px 5px 5px 5px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 16px;
        cursor: pointer;
        color: #16bbad;
        &:hover {
            color: #ffffff;
            background: #0dd8bd;
        }
    }
    .login-info {
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        width: 143px;

        .default-avt {
            width: 40px;
            height: 40px;
            margin-right: 9px;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            background: #fafafa;
            flex-shrink: 0;

            .image-slot {
                width: 40px;
                height: 40px;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-shrink: 0;
                img {
                    width: 40px;
                    height: 40px;
                    flex-shrink: 0;
                }
            }
        }
        .info-arrow {
            width: 6px;
            margin-left: 6px;
        }
    }
}
.el-dropdown-link {
    display: flex;
    justify-content: center;
    align-items: center;
    .user-name {
        max-width: 95px;
        flex-shrink: 0;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        line-height: 1;
        text-overflow: ellipsis;
        word-wrap: break-word;
    }
}
.el-dropdown-menu {
    padding: 0;
    .el-dropdown-menu__item {
        height: 55px;
    }
}

.drop-item {
    height: 55px;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover {
        color:#0dd8bd;
    }
    img {
        width: 18px;
        height: 16px;
        margin-right: 6px;
    }
}
</style>
